import React from 'react';
import {HelperVar} from "../../../helper/helperVar";

interface Props {
    item: any

}

export class ProductName extends React.Component<Props, {}> {


    componentDidMount() {
    }

    render() {

        let item: any = this.props.item


        return (
            <>
                <span className="goods-content-text__description">{item.name}</span>
                <div className="goods-content-text__count">{HelperVar.defaultVar(item.propsNoFilter.inBox)} шт в упаковке</div>

            </>
        )
    }
}

